import { useSettings } from "master";

export const useTermsAndCondition = ({ load = false, key = "" }) => {
  const { settingsInfo } = useSettings({ load, key });
  return {
    settingsInfo,
  };
};
